/** Small shared pieces: avatars and the CI check badge. */
import { CheckCircle, Clock, DotCircle, XCircle } from './Icons'
import { initials } from '../lib/format'
import type { CheckState, Person } from '../types'

export function Avatar({ person, large = false }: { person: Person; large?: boolean }) {
  const cls = large ? 'avatar avatar-lg' : 'avatar'
  if (person.avatar) {
    return <img className={cls} src={`${person.avatar}${person.avatar.includes('?') ? '&' : '?'}s=64`} alt="" loading="lazy" />
  }
  return <span className={cls}>{initials(person.name)}</span>
}

const CHECK_LABEL: Record<string, string> = {
  success: 'checks passing',
  failure: 'checks failing',
  error: 'checks errored',
  pending: 'checks running'
}

export function Checks({ state, label = false }: { state: CheckState; label?: boolean }) {
  if (!state) {
    return label ? (
      <span className="check none" title="No checks reported for this commit">
        <DotCircle size={13} /> no checks
      </span>
    ) : null
  }
  const Icon = state === 'success' ? CheckCircle : state === 'pending' ? Clock : XCircle
  return (
    <span className={`check ${state}`} title={CHECK_LABEL[state]}>
      <Icon size={13} />
      {label ? CHECK_LABEL[state].replace('checks ', '') : null}
    </span>
  )
}
